export function formatPriceToLakhs(price: number): string {
    if (typeof price !== 'number') {
        return "N/A";
    }
    const priceInLakhs = price / 100000;
    return `${priceInLakhs.toFixed(2)}`;
} 